import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

const useStyles = makeStyles<propsType>(
  theme => ({
    spacer: {
      marginTop: ({ space }) => (space ? `${space}px` : theme.spacing(3))
    }
  }),
  { name: "FormSpacer" }
);
interface propsType {
  space?: number;
}
interface FormSpacerProps {
  children?: React.ReactNode;
  space?: number;
}

export const FormSpacer: React.FC<FormSpacerProps> = props => {
  const { children, space } = props;

  const classes = useStyles({
    space
  });

  return <div className={classes.spacer}>{children}</div>;
};

FormSpacer.displayName = "FormSpacer";
export default FormSpacer;
